module.exports = function isBoolean(x) {
  return x === true || x === false;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb-form/~/tcomb/lib/isBoolean.js
 ** module id = 497
 ** module chunks = 0
 **/